//const baseUrl = 'https://post2.gennet.com/api';
//const baseUrl = 'http://192.168.0.111:3000/api';
//const baseUrl = 'http://localhost:3000/api';
//const baseUrl = '/api'
const baseUrl = process.env.API_URL;

const endpoints = {
  getPlaylist: `${baseUrl}/playlist`,
  getUser: `${baseUrl}/user`,
  getTimecard: `${baseUrl}/timecards/{timecardId}`,
  createTimecard: `${baseUrl}/timecards`,
  getKpiDetails: `${baseUrl}/kpidetails/{timecardId}`,
  getIncidents: `${baseUrl}/incidents`,
  createEntry: `${baseUrl}/entries`,
  deleteEntry: `${baseUrl}/entries{id}`,
  putEntry: `${baseUrl}/entries/{id}`,
  putDraft: `${baseUrl}/running-draft/{id}`,
  postEntry: `${baseUrl}/entries`,
  deleteEntry: `${baseUrl}/entries/{id}`,
  putWorkday: `${baseUrl}/workdays/{id}`,
  submit: `${baseUrl}/timecards/{id}/submit`,
  retract: `${baseUrl}/timecards/{id}/retract`,
  getCalendarEvents: 'https://graph.microsoft.com/v1.0/me/calendarview',
  getCalendarEvents2:
    'https://graph.microsoft.com/v1.0/me/calendarview?startdatetime=2021-01-11T00:21:14.554Z&enddatetime=2021-01-11T23:21:14.554Z',
  receiptAnalysis: `${baseUrl}/receiptAnalysis`
};

export default endpoints;
